import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link, Redirect } from 'react-router-dom';
import config from '../config';
import styled from 'styled-components';
import posts from '../assets/blogs';

const BlogStyles = styled.div`
  padding: 10rem 0 6rem;
  min-height: 100vh;

  .blog__heading {
    margin-bottom: 1rem;
  }

  .blog__subheading {
    font-size: 1.4rem;
    color: var(--gray-1);
    opacity: 0.6;
    margin-bottom: 5rem;
    text-transform: uppercase;
    letter-spacing: 0.2rem;
  }

  .blog__grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
    gap: 3rem;
    margin-top: 3rem;
  }

  .blog__card {
    background: var(--deep-dark);
    border: 1px solid var(--gray-2);
    border-radius: 12px;
    padding: 2.8rem;
    display: flex;
    flex-direction: column;
    transition: border-color 0.2s ease, transform 0.2s ease;
    &:hover {
      border-color: var(--highlight-blue);
      transform: translateY(-3px);
    }
  }

  .blog__card__tags {
    display: flex;
    flex-wrap: wrap;
    gap: 0.8rem;
    margin-bottom: 1.4rem;
  }

  .blog__tag {
    font-size: 1.1rem;
    background: var(--gray-2);
    color: var(--highlight-blue);
    border-radius: 4px;
    padding: 0.3rem 0.9rem;
    text-transform: uppercase;
    letter-spacing: 0.1rem;
  }

  .blog__card__title {
    font-size: 2.2rem;
    font-family: 'Montserrat SemiBold';
    color: var(--gray-1);
    margin-bottom: 1rem;
    line-height: 1.3;
  }

  .blog__card__meta {
    font-size: 1.2rem;
    color: var(--gray-1);
    opacity: 0.5;
    margin-bottom: 1.6rem;
    display: flex;
    gap: 1.5rem;
  }

  .blog__card__excerpt {
    font-size: 1.5rem;
    line-height: 1.7;
    color: var(--gray-1);
    opacity: 0.8;
    flex: 1;
    margin-bottom: 2.4rem;
  }

  .blog__card__link {
    font-size: 1.4rem;
    color: var(--highlight-blue);
    letter-spacing: 0.05rem;
    align-self: flex-start;
    border-bottom: 1px solid transparent;
    transition: border-color 0.2s ease;
    &:hover {
      border-color: var(--highlight-blue);
    }
  }

  .blog__card--coming-soon {
    opacity: 0.5;
    border-style: dashed;
    cursor: default;
    &:hover {
      transform: none;
      border-color: var(--gray-2);
    }
  }

  .blog__empty {
    font-size: 1.6rem;
    opacity: 0.5;
    text-align: center;
    margin-top: 6rem;
  }

  @media only screen and (max-width: 768px) {
    padding: 8rem 0 4rem;
    .blog__grid {
      grid-template-columns: 1fr;
    }
  }
`;

export default function Blog() {
  if (!config.blogEnabled) return <Redirect to="/" />;

  return (
    <BlogStyles>
      <Helmet><title>Blog | Anas Qazi</title></Helmet>
      <div className="container">
        <p className="blog__subheading">thoughts &amp; writings</p>
        <h1 className="blog__heading">Blog</h1>

        {posts.length === 0 ? (
          <div className="blog__grid">
            <div className="blog__card blog__card--coming-soon">
              <div className="blog__card__tags">
                <span className="blog__tag">coming soon</span>
              </div>
              <h2 className="blog__card__title">Posts incoming...</h2>
              <p className="blog__card__excerpt">
                I'm working on some posts — check back soon.
              </p>
            </div>
          </div>
        ) : (
          <div className="blog__grid">
            {posts.map((post) => (
              <div className="blog__card" key={post.slug}>
                <div className="blog__card__tags">
                  {post.tags.map((tag) => (
                    <span className="blog__tag" key={tag}>{tag}</span>
                  ))}
                </div>
                <h2 className="blog__card__title">{post.title}</h2>
                <div className="blog__card__meta">
                  <span>{post.date}</span>
                  <span>{post.readTime}</span>
                </div>
                <p className="blog__card__excerpt">{post.excerpt}</p>
                <Link className="blog__card__link" to={`/blog/${post.slug}`}>
                  Read more →
                </Link>
              </div>
            ))}
          </div>
        )}
      </div>
    </BlogStyles>
  );
}
